import React from 'react';
import {
  CardDs, Text, Link
} from '@comicrelief/component-library';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Anton = props => <Text family="Anton" size="xl" weight="normal" {...props} />;
const P = props => <Text family="Montserrat" tag="p" size="s" {...props} />;

export const Notice = styled(CardDs)`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 3rem;

  > div {
    margin: 0;
    border-radius: 0;

    ${({ showReducedCopy }) => (showReducedCopy) && css`
      padding: 0;
    `}
  }

  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding: 0 1.5rem;

     > div {
      border-radius: 1rem;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 20px;
      padding: 4rem;
    }
  }
`;

const DataProtectionNotice = (props) => {
  const { hasPhoneField = false, showReducedCopy } = props;
  return (
    <Notice showReducedCopy={showReducedCopy}>

      {!showReducedCopy ? (
        <>
          <Anton size="m">Your data</Anton>
          <Anton tag="h4" css={{ marginTop: 0 }}>
            Why do we collect your
            {' '}
            <Anton color="red">information</Anton>
            ?
          </Anton>
          <P weight="bold">Name, surname, email and address</P>
          <P>
            We need these to process your registration,
            to identify if you&apos;ve fundraised with us before
            and to make sure you have all the information you need.
          </P>
          <P weight="bold">Establishment information</P>
          <P>
            We use this information to better understand which
            institutions (schools, companies, etc.)
            raise money for us.
          </P>
          { hasPhoneField && (
          <>
            <P weight="bold">Phone number</P>
            <P>
              This is optional and we will only use this number to contact you
              regarding your fundraising to offer additional support.
            </P>
          </>
          )}
        </>
      ) : (
        <>
          <P>
            You can read about how we use your information
            {' '}
            <Link
              color="red"
              href="https://www.comicrelief.com/privacy-notice/"
              target="blank"
            >
              here
            </Link>
            .
          </P>
        </>
      )}

    </Notice>
  );
};

DataProtectionNotice.propTypes = {
  hasPhoneField: PropTypes.bool,
  showReducedCopy: PropTypes.bool
};

export default DataProtectionNotice;
